import { Link } from 'react-router-dom';


export default function DocumentsStart({selectedYear, isPastYear}) {
  return (
    <>
      <div className="row">
        <h3 className="m-3">О разделе</h3>
      </div>
      <div className="m-3 p-4 lk-start-page">
        <p>
          В этом разделе собрано всё, что связано с оформлением участия в МСИ «ФСВОК» на {selectedYear} год:
          выбор позиций каталога, заказ, договор, счет и бухгалтерские документы.
        </p>
        <ul>
          {isPastYear ?
            <li className="mb-2">
              Каталог прошлых лет недоступен: для выбранного года можно посмотреть оформленный заказ и документы.
            </li>
          :
            <li className="mb-2">
              <Link to="/documents/catalog">Каталог</Link> — выбор программ МСИ и добавление позиций в корзину.
              Из корзины оформляется заказ.
            </li>
          }
          <li className="mb-2">
            <Link to="/documents/order">Заказ и договор</Link> — бланк заказа, формирование и подписание договора,
            счет, закрывающие документы и акты сверки.
          </li>
          <li className="mb-2">
            <Link to="/documents/tickets">Обращения</Link> — вопросы договорному отделу АСНП ЦВКК
            по заключению договора, заказу и документам.
          </li>
        </ul>
        <p className="mb-0 text-secondary">
          <small>Год договора меняется переключателем «год договора» в левой панели.</small>
        </p>
      </div>
    </>
  );
}
